import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=2b2d0108&scoped=true&"
import script from "./Bar.vue?vue&type=script&lang=js&"
export * from "./Bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d0108",
  null
  
)

export default component.exports